import ChallengesContainer from './challenges_container';

const Challenges = ChallengesContainer;
export default Challenges;
